import React from 'react';

interface ProfessionalInfoCardProps {
  city: string;
  logoUrl?: string;
  businessName: string;
}

const ProfessionalInfoCard: React.FC<ProfessionalInfoCardProps> = ({ city, logoUrl, businessName }) => {
  return (
    <div className="flex flex-col gap-4 p-4 border rounded-xl shadow-sm bg-white">
      {/* Top: Logo + Infos */}
      <div className="flex flex-row items-center gap-4">
        {/* Logo */}
        <div className="flex-shrink-0">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={`${businessName} logo`}
              className="w-20 h-20 rounded-full object-cover"
            />
          ) : (
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center">
              <svg
                className="w-5 h-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </div>
          )}
        </div>

        {/* Informations */}
        <div className="flex flex-col justify-center">
          <h2 className="text-2xl font-semibold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
            {businessName}
          </h2>
          {city && (
            <a
            href={`https://www.google.com/maps/search/${encodeURIComponent(city)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-gray-700 rounded-2xl text-sm font-medium mt-1 hover:underline hover:text-blue-600"
            >          
              <svg
                className="w-4 h-4 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              {city}
            </a>
          )}
        </div>
      </div>

      {/* TODO: Styled element */}
      <div className="border-t pt-4">
        <p className="text-sm text-gray-500 italic">
          L'adresse complète vous sera communiqué dans le mail de confirmation.
        </p>
      </div>
    </div>
  );
};

export default ProfessionalInfoCard;
